import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Form from 'components/common/Form';
import Button, { ButtonStyles } from 'components/common/Form/Button';

import style from 'components/Welcome/Form/Form.module.scss';
import cn from 'classnames';
import { GreenPlusIcon } from 'components/common/icons';
import { LanguageRow } from 'components/common/Form/SelectLanguagePairs/SelectLanguagePairs';

export default function TranslationForm({ data, onChange, onNextStep, validateForm, errors, isLastStep }) {
    const { translateLanguages } = data;
    const { t } = useTranslation();
    const [languageRows, setLanguageRows] = useState(translateLanguages || []);

    useEffect(() => {
        delete errors.translate;
    }, [languageRows]);

    const handleAddButtonClick = () => {
        setLanguageRows((prevState) => [...prevState, { from: null, to: null }]);
    };

    const handleDeleteClick = (ind) => {
        const newRows = languageRows.filter((item, index) => index !== ind);
        setLanguageRows([...newRows]);
        validateForm(newRows);
    };

    const handleChange = (type, ind, value) => {
        const newRows = [...languageRows];
        newRows[ind][type] = value;
        setLanguageRows([...newRows]);
    };

    const handleNextStep = () => {
        validateForm(languageRows, (e) => {
            if (e.translate) return;
            onChange('translateLanguages', [...languageRows]);
            onNextStep();
        });
    };

    const buttonText = (
        <>
            <GreenPlusIcon /> {t('welcome:buttons.addPair')}
        </>
    );

    return (
        <div className={style.profileFormContainer}>
            <Form className={cn(style.form, style.wideForm)}>
                <div className={style.translationHeader}>{t('welcome:form.labels.languagePairs')}</div>
                {languageRows.map((row, index) => (
                    <LanguageRow
                        key={index}
                        index={index}
                        onDeleteClick={handleDeleteClick}
                        onChangeClick={handleChange}
                        from={row.from}
                        to={row.to}
                    />
                ))}
                <div className={style.commonError}>{t(errors.translate)}</div>
                <div className={cn(style.buttonWrapper, style.addButton)}>
                    <Button text={buttonText} onClick={handleAddButtonClick} />
                </div>
                {isLastStep && <div className={style.commonError}>{errors.common}</div>}
                <div className={cn(style.buttonWrapper, style.withMargins)}>
                    <Button
                        text={t('welcome:buttons.getStarted')}
                        onClick={handleNextStep}
                        btnStyle={ButtonStyles.primary}
                    />
                </div>
            </Form>
        </div>
    );
}
